import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { getIconSize } from '../utilities/index.js';
const MinusCircled = forwardRef(({ size = 'medium', fill = 'currentColor', innerFill = 'transparent', ...props }, ref) => {
    const innerFillValue = innerFill === 'transparent' ? 'transparent' : 'var(--cb-icon-inner-color-contrast)';
    const { iconWidth, iconHeight } = getIconSize(size);
    const ariaLabel = props['aria-label'];
    const ariaLabelledby = props['aria-labelledby'];
    let ariaHidden = true;
    if (ariaLabel || ariaLabelledby) {
        ariaHidden = false;
    }
    return (_jsxs("svg", { xmlns: "http://www.w3.org/2000/svg", viewBox: "0 0 20 20", ref: ref, fill: fill, width: iconWidth, height: iconHeight, "aria-hidden": ariaHidden, ...props, children: [_jsx("path", { fillRule: "evenodd", d: "M20 10c0 5.523-4.477 10-10 10S0 15.523 0 10 4.477 0 10 0s10 4.477 10 10m-4.167 0c0 .66-.45 1.25-1.064 1.25H5.231c-.594 0-1.064-.568-1.064-1.25 0-.66.45-1.25 1.064-1.25h9.538c.594 0 1.064.568 1.064 1.25" }), _jsx("path", { d: "M15.833 10c0 .66-.45 1.25-1.064 1.25H5.231c-.594 0-1.064-.568-1.064-1.25 0-.66.45-1.25 1.064-1.25h9.538c.594 0 1.064.568 1.064 1.25", fill: innerFillValue })] }));
});
MinusCircled.displayName = 'MinusCircled';
MinusCircled.__iconComponentType = 'contrast';
export default MinusCircled;
//# sourceMappingURL=MinusCircled.js.map